const INTERNAL_ROLE_OVERRIDES: Record<string, string[]> = {
  'yl@linfinityeng.com': ['admin'],
  'jp@linfinityeng.com': ['admin'],
  'wd@linfinityeng.com': ['admin'],
};

const AI_EMAIL_REVIEW_ALLOWED_EMAILS = new Set([
  'yl@linfinityeng.com',
]);

export function normalizeEmail(email?: string | null) {
  return String(email || '').trim().toLowerCase();
}

export function normalizeRoles(userRoles?: string[] | null) {
  return (userRoles || []).map((role) => String(role || '').trim().toLowerCase()).filter(Boolean);
}

export function getRoleOverridesForEmail(userEmail?: string | null) {
  return INTERNAL_ROLE_OVERRIDES[normalizeEmail(userEmail)] || [];
}

export function getEffectiveRoles(userRoles?: string[] | null, userEmail?: string | null) {
  return Array.from(new Set([
    ...normalizeRoles(userRoles),
    ...getRoleOverridesForEmail(userEmail),
  ]));
}

export function hasAdminEquivalentAccess(userRoles?: string[] | null, userEmail?: string | null): boolean {
  return getEffectiveRoles(userRoles, userEmail).includes('admin');
}

export function canAccessAiEmailReview(userEmail?: string | null): boolean {
  return AI_EMAIL_REVIEW_ALLOWED_EMAILS.has(normalizeEmail(userEmail));
}

export function hasRequiredRoleAccess(
  userRoles?: string[] | null,
  userEmail?: string | null,
  requiredRoles: string[] = []
): boolean {
  if (!Array.isArray(requiredRoles) || requiredRoles.length === 0) {
    return true;
  }

  if (hasAdminEquivalentAccess(userRoles, userEmail)) {
    return true;
  }

  const roles = getEffectiveRoles(userRoles, userEmail);
  return requiredRoles.some((role) => roles.includes(String(role || '').trim().toLowerCase()));
}

export function getPrimaryRoleLabel(userRoles?: string[] | null, userEmail?: string | null): string {
  const roles = getEffectiveRoles(userRoles, userEmail);
  if (hasAdminEquivalentAccess(userRoles, userEmail)) return 'admin';
  for (const preferredRole of ['pm', 'finance']) {
    if (roles.includes(preferredRole)) {
      return preferredRole;
    }
  }

  const meaningful = roles.filter((role) => !['anonymous', 'authenticated', 'user'].includes(role));
  return meaningful[0] || 'user';
}
